import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gamesPageLayout from '../constants/layoutConstants';

function GameContainerHeader({ translate, headerLabel, isSeeAllHidden }) {
  const seeAllClassNames = classNames(gamesPageLayout.seeAllClass, { hidden: isSeeAllHidden });

  return (
    <div className='container-header games-filter-changer'>
      <h3>{headerLabel}</h3>
      <span className={seeAllClassNames}>{translate(gamesPageLayout.seeAllLinkLabel)}</span>
    </div>
  );
}

GameContainerHeader.defaultProps = {
  isSeeAllHidden: false
};

GameContainerHeader.propTypes = {
  translate: PropTypes.func.isRequired,
  headerLabel: PropTypes.string.isRequired,
  isSeeAllHidden: PropTypes.bool
};

export default GameContainerHeader;
